export const RELEASE_LOTS_ROUTE = 'projects/:id/releases/:releaseId/lots/:cbTabRouteId';
